import makeSlice from '@web/slices/purchaser/sliceMaker'

import {initPaymentMethodManagement, registerPaymentMethods} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initPaymentMethodManagement.fulfilled, (state, {payload}) => {
                const {response} = payload

                state.isPaymentMethodRegistered = !!response.prevPaymentMethodInfo?.isRegistered

                state.adult = response.memberInfoResult.adult
                state.isAMLTarget = response.memberInfoResult.isAMLTarget
            })
            .addCase(registerPaymentMethods.fulfilled, (state) => {
                state.isPaymentMethodRegistered = true
            })
    },
})

export default slice.reducer
